import DefaultAPIErrorHandler from '@rover/react-lib/src/apis/DefaultAPIErrorHandler';
import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize, snakeifyString } from '@rover/rsdk/src/modules/Network/object-utilities';
import { PetType } from '@rover/types/src/Pet';
import type { ServiceTypeSlug } from '@rover/types/src/ServiceType';
import { fullApiUrl } from '@rover/utilities/apiUrl';

export type Response = Array<{
  slug: ServiceTypeSlug;
  webAction: string;
}>;
export type LocationParams = {
  lat: string;
  lng: string;
  postalCode: string;
  countryCode: string;
  locationName: string;
  locationType: string;
  rawLocationTypes: string[];
};
export const homepageServiceTypesUrl = fullApiUrl('frontend/homepage-service-types/');
export const GET_ERROR_MESSAGE = 'Something went wrong when fetching the homepage service types';
export const buildRequest = (
  petTypes: PetType[],
  locationParams: LocationParams | null = null
): any => {
  // Build the query params in the correct format
  const params = new URLSearchParams();
  petTypes.forEach((p) => {
    params.append('pet_type', p);
  });

  if (locationParams) {
    const { rawLocationTypes, ...localParams } = locationParams;
    Object.keys(localParams).forEach((key) => {
      if (localParams) {
        const value = localParams[key];

        if (value) {
          params.append(snakeifyString(key), value);
        }
      }
    });

    if (rawLocationTypes) {
      rawLocationTypes.forEach((p) => {
        params.append('raw_location_types', p);
      });
    } else {
      params.append('raw_location_types', '');
    }
  }

  return {
    params,
  };
};
export const get = async (
  petTypes: PetType[],
  locationParams: LocationParams | null = null // eslint-disable-line default-param-last
): Promise<Response> => {
  const ai = getAxiosInstance();
  const request = buildRequest(petTypes, locationParams);

  try {
    const response = await ai.get<Snakeify<Response>>(homepageServiceTypesUrl, request);
    return camelize(response.data, true);
  } catch (e: any) {
    throw DefaultAPIErrorHandler(e, GET_ERROR_MESSAGE);
  }
};
